import React, { useEffect, useState, useContext, useRef } from 'react'
import { ContentInner } from '../../../../../layout/Content'
import ProductsInventoryInnerStyle from './css/ProductsInventoryInnerStyle'
import { appContext } from '../../../../../../App'
import { productsInventoryControllerContext } from './ProductsInventoryController'
import { formatNumber } from '../../../../../utilities/utilities'
import PrinterSettingsStyle from '../../../../../../css/PrinterSettingsStyle'

function ProductsListContents(props) {
  const products = props.products
  const classification = props.classification

  const getAccumulatedUnitQuantity = (product, currentUnit) => {
    let totalAccumulatedUnitQuantity = 0

    const unitsCurrentUnitExcluded = product.units
    .filter(unit => unit.description !== currentUnit.description)

    // Is there siblings units
    if (unitsCurrentUnitExcluded.length > 0) {

      // Loop in each unit
      unitsCurrentUnitExcluded
      .forEach((unit, i) => {

        let accumulatedUnitQuantity = 1

        if (unit.description.search(currentUnit.unit_name) > 0) {
          // A child of a container
          const unitDescriptionSplitted = unit.description.split('(').filter(item => parseFloat(item))

          if (unitDescriptionSplitted.length > 0) {
            let i = 0
            let found = false

            while (!found && (i < unitDescriptionSplitted.length)) {
              accumulatedUnitQuantity *= parseFloat(unitDescriptionSplitted[i])
              found = (unitDescriptionSplitted[i++].search(currentUnit.unit_name) > 0)
            }
            accumulatedUnitQuantity *= parseFloat(unit.inventory)
          }
        } else if (currentUnit.description.search(unit.unit_name) > 0) {
          // A container
          const unitDescriptionSplitted = currentUnit.description.split('(').filter(item => parseFloat(item))

          if (unitDescriptionSplitted.length > 0) {
            let i = 0
            let found = false

            while (!found && (i < unitDescriptionSplitted.length)) {
              accumulatedUnitQuantity *= parseFloat(unitDescriptionSplitted[i])
              found = (unitDescriptionSplitted[i++].search(unit.unit_name) > 0)
            }
            accumulatedUnitQuantity = parseInt(unit.inventory / accumulatedUnitQuantity)
          }
        } else {
          // If units have same contents
          // Ex: Promo1(5xKilo), Promo2(2.5xKilo)
          if (unit.contents === currentUnit.contents) {
            accumulatedUnitQuantity = parseInt((unit.contents_quantity * unit.inventory) / currentUnit.contents_quantity)
          }
        }

        // Sum per unit loop
        totalAccumulatedUnitQuantity +=  accumulatedUnitQuantity

      } )

      // Add the current unit inventory at the end
      totalAccumulatedUnitQuantity +=  currentUnit.inventory

    } else {
      // There is no other unit than the current
      totalAccumulatedUnitQuantity = currentUnit.inventory
    }

    return (totalAccumulatedUnitQuantity)
  }

  return (
    <React.Fragment>
      <div id='warehouse-inventory-container'>
        <table className='inventory-table'>
          <thead>
            <tr>
              <th style={{textAlign: 'left'}}>Item Name</th>
              <th style={{textAlign: 'left'}}>Unit</th>
              <th>Inventory</th>
              <th>Accumulated Inventory</th>
            </tr>
          </thead>
          {
            products.filter(product => (product.classification === classification)).map(product => (
              product.units.map((unit, index) => (
                <tbody key={index}>
                  <tr>
                    <td style={{textAlign: 'left'}}>{product.brand} {product.name} {product.description}</td>
                    <td>{unit.description}</td>
                    <td style={{textAlign: 'center'}}>{formatNumber(unit.inventory.toFixed(2))}</td>
                    <td style={{textAlign: 'center'}}> { formatNumber(getAccumulatedUnitQuantity(product, unit)) } </td>
                  </tr>
                </tbody>
              ))
            ))
          }
        </table>
      </div>
    </React.Fragment>
  )
}

function useProductsInventory(props) {
  const app = useContext(appContext)
  const productsInventoryController = useContext(productsInventoryControllerContext)
  const { filter, getWarehouses, getProductsInventory } = productsInventoryController 
  const [productsInventory, setProductsInventory] = useState(null)
  const classificationFilter = useRef([])
  const warehouseFilter  = useRef([])

  useEffect(() => {
    const initProductsInventory = async (warehouses) => {
      const prodInv = []

      for (let warehouse of warehouses) {
        // Filter the warehouse
        if (warehouseFilter.current.find(wh => (wh === warehouse.name))) {
          let products = await getProductsInventory(app, warehouse._id)

          // Filter the products
          products = products.filter(product => (
              classificationFilter.current.find(classification => (classification === product.classification))
            )
          )

          prodInv.push (
            {
              wh: warehouse,
              products: products
            }
          )
        }
      }
      setProductsInventory(prodInv)
    }

    const init = async () => {
      // Warehouse filter
      for (let key in filter.warehouse) {
        if (filter.warehouse[key]) {
          //push into temp array here
          warehouseFilter.current.push(key)
        }
      }

      // Classification filter
      for (let key in filter.classification) {
        if (filter.classification[key]) {
          classificationFilter.current.push(key)
        }
      }

      initProductsInventory(await getWarehouses(app))
    }

    init()

    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return ({
    app,
    productsInventory: [productsInventory, setProductsInventory],
    classifications: classificationFilter
  })

}

function ProductsInventoryInner(props) {
  const productsInventory = useProductsInventory(props)
  const { app } = productsInventory
  const prodInv = productsInventory.productsInventory[0]
  const classifications = productsInventory.classifications

  return (
    <ContentInner>
      <div className='report-wrapper'>
        <div id='products-list-container' className='printable'>
          {
            (prodInv) ?
              prodInv.map((pi, i) => (
                <div key={i} className={ (i === 0) ? 'firstpage' : (i === (prodInv.length - 1)) ? 'lastpage' : 'pagebreak' }>
                  <div className='products-inventory-header-container'>
                    <div className='products-inventory-header'>Products Inventory</div>
                    <div className='products-inventory-date'>As of {new Date(app.getClientDateTime()).toLocaleString("en-us")} { app.getClientTimezone() }</div>
                  </div>
                  <br />
                  <div className='warehouse-name'><b>Warehouse:</b> {pi.wh.name}</div>
                  <hr />
                  {
                    classifications.current.map((classification, index) => (
                      <div key={index}>
                        <div><b>Classification:</b> {classification}</div>
                        <div className='products-list-contents-wrapper'>
                          <ProductsListContents products={pi.products} classification={classification}/>
                        </div>
                      </div>
                    ))
                  }
                </div>
              ))
            : null
          }
        </div>
      </div>
      <ProductsInventoryInnerStyle />
      <PrinterSettingsStyle paperWidth='8.5inch'/>
    </ContentInner>
  )
}

export default React.memo(ProductsInventoryInner)